import React, { useCallback, useEffect, useState } from 'react';
import { Card } from '../../components/ui/card';
import { laborApi } from '../api';
import { fmtMinutes, costDisplay } from '../laborConstants';
import { TimeEntriesView } from './TimeEntriesView';

export const ProjectLaborTab = ({ project }) => {
  const [breakdown, setBreakdown] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  const loadBreakdown = useCallback(() => {
    laborApi.projectBreakdown(project.id).then((r) => setBreakdown(r.data)).catch(() => {});
  }, [project.id]);

  useEffect(() => { loadBreakdown(); }, [loadBreakdown, refreshKey]);

  return (
    <div data-testid="project-labor-tab">
      <p className="text-xs text-gray-500 mb-4">
        Project labor cost comes only from approved time entries using each employee's internal cost rate snapshot.
        Employee payments never affect project costs.
      </p>

      {breakdown.length > 0 && (
        <Card className="bg-[#111111] border-gray-800 p-5 mb-5" data-testid="project-labor-breakdown">
          <h4 className="text-sm font-semibold text-[#D4AF37] uppercase tracking-wide mb-3">Labor by Employee</h4>
          <div className="space-y-1">
            {breakdown.map((r) => (
              <div key={r.employee_id} className="flex flex-wrap items-center justify-between gap-2 py-2 border-b border-gray-800/60 last:border-0" data-testid={`labor-breakdown-${r.employee_id}`}>
                <span className="text-sm text-gray-200">{r.display_name}</span>
                <span className="text-sm text-gray-400">
                  {fmtMinutes(r.approved_minutes)} · <span className="text-gray-200">{costDisplay(r.recorded_labor_cost_cents)}</span>
                  {r.missing_labor_cost_entry_count > 0 && (
                    <span className="text-amber-400/90 text-xs ml-2">({r.missing_labor_cost_entry_count} without cost rate)</span>
                  )}
                </span>
              </div>
            ))}
          </div>
        </Card>
      )}

      {project.is_archived && (
        <div className="text-sm text-gray-400 bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2 mb-4" data-testid="labor-archived-note">
          This Project is archived. Existing time entries are preserved, but new time cannot be logged against it.
        </div>
      )}

      <TimeEntriesView
        lockedProjectId={project.id}
        disableAdd={project.is_archived}
        onChanged={() => setRefreshKey((k) => k + 1)}
      />
    </div>
  );
};
